import { render, staticRenderFns } from "./exped_calculos.vue?vue&type=template&id=49d6a287"
import script from "./exped_calculos.vue?vue&type=script&lang=js"
export * from "./exped_calculos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports